import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';

const Series = ({ content, onVideoPlay }) => {
    const handleVideoClick = (videoData) => {
        if (onVideoPlay && videoData) {
            onVideoPlay(videoData);
        }
    };

    return (
        <div className={styles.series}>
            <div className={styles.bigPic}>
                <img
                    src={content?.[0]?.thumbnails?.image?.[0]?.url}
                    onClick={() => {
                        handleVideoClick(content?.[0]);
                    }}
                    className={styles.bigPicUrl}
                />
            </div>
            {content.length >= 2 && (
                <div className={styles.seriesList}>
                    <div className={styles.seriesBox}>
                        {content.slice(1).map((item, index) => (
                            <div
                                className={styles.seriesItem}
                                key={index}
                                onClick={() => {
                                    handleVideoClick(item);
                                }}>
                                <img className={styles.seriesItemPic} src={formatImage(item?.thumbnails?.image?.[0]?.url, 232, 150)} />
                                <div className={styles.seriesItemTitle}>{item.title}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

Series.propTypes = {
    content: PropTypes.array,
    onVideoPlay: PropTypes.func,
};

export default errorBoundary(Series);
